import * as React from "react";
function SvgFullscreen(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <g clipPath="url(#fullscreen_svg__clip0_1347_7087)">
                <path
                    d="M7.293 14h-2v5h5v-2h-3v-3zm-2-4h2V7h3V5h-5v5zm12 7h-3v2h5v-5h-2v3zm-3-12v2h3v3h2V5h-5z"
                    fill="currentcolor"
                />
            </g>
            <defs>
                <clipPath id="fullscreen_svg__clip0_1347_7087">
                    <path
                        fill="#fff"
                        transform="translate(.293)"
                        d="M0 0h24v24H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgFullscreen);
export default ForwardRef;
